import { apiPlugin, storyblokInit } from '@storyblok/react'
import { env } from '@percent/cause-dashboard/env'
import { isStoryblokPreviewSearch } from '@percent/cause-dashboard/storyblok/helpers/isStoryblokPreviewSearch'

function noopBlok() {
  return null
}

function accessTokenForStoryblokInit(): string {
  const publicToken = env.NX_PUBLIC_STORYBLOK_PUBLIC_ACCESS_TOKEN
  const previewToken = env.NX_PUBLIC_STORYBLOK_PREVIEW_ACCESS_TOKEN

  if (typeof window !== 'undefined') {
    const searchParams = new URLSearchParams(window.location.search)
    if (isStoryblokPreviewSearch(searchParams) && previewToken) {
      return previewToken
    }
  }

  return publicToken ?? '__storyblok_token_unset__'
}

/**
 * Registers Storyblok SDK once. Uses a placeholder token when unset so the module
 * loads in tests/CI; callers must check env before calling the CDN.
 * In the Visual Editor (`_storyblok` / `_storyblok_tk`), uses the preview token so
 * `getStoryblokApi()` follow-ups (e.g. relation `by_uuids` with `version=draft`) match
 * the token used in `useProductOffersPageStory`.
 * Bloks are no-ops here — `/product-offers` maps `page.body` manually in React.
 */
storyblokInit({
  accessToken: accessTokenForStoryblokInit(),
  use: [apiPlugin],
  apiOptions: {
    region: 'eu',
    cache: {
      type: 'memory',
      clear: 'auto'
    }
  },
  components: {
    page: noopBlok,
    product_offers_section: noopBlok,
    product_offer: noopBlok,
    product_offer_page: noopBlok,
    product_offer_cta_cards_group: noopBlok,
    product_offer_cta_card: noopBlok,
    link_button: noopBlok,
    banners_carousel: noopBlok,
    banner: noopBlok,
    native_apply_modal_button: noopBlok,
    spotlight_banner: noopBlok
  }
})
